import React, { FC } from 'react';
import { serverSideTranslation } from '../../../../util/next';

import { initSmartSiteData } from '../../../../api/smartApi';
import { getPageContent } from '../../../../api/pagesApi';

import { SmartPageContainer } from '../../../../components/SmartPageContainer';
import NewsFooter from '../../../../modules/NewsFooter';

const BabyKangaroo: FC = (props: any) => {
  const { _nextI18Next: i18n, pageContentData } = props;
  const { shareContent = {} } = pageContentData || {};
  const description = shareContent.shareDetail || '市场协同治理';
  const title = shareContent.shareTitle || '市场协同治理';
  const pageUrl = '/csr/society/disaster-relief/covid-19/meituan';

  return (
    <>
      <SmartPageContainer title={title} description={description} pageUrl={pageUrl} {...props} />
      <div className="bg-white">
        <NewsFooter category="csr" lanType={i18n.initialLocale} positionNo="csr_15" />
      </div>
    </>
  );
};
export async function getServerSideProps({ locale, query }: any) {
  const pageContentParams = {
    uri: '/csr/society/disaster-relief/covid-19',
    pageContentNo: query.pageContentNo,
    preview: query.preview,
  };
  const pageContentData = await getPageContent(pageContentParams, locale);
  return {
    props: {
      pageContentData,
      ...(await initSmartSiteData(locale)),
      ...(await serverSideTranslation(locale, ['home', 'cookie', 'common'])),
    },
  };
}
export default BabyKangaroo;
